<template>
  <div class="month-selector">
    <div class="month-selector__calendar-types">
      <ElRadio
        :label="calendars.JALALI"
        :value="calendarType"
        @change="updateCalendarType(calendars.JALALI)"
      >
        {{ $t('JALALI_CALENDAR') }}
      </ElRadio>

      <ElRadio
        :label="calendars.GREGORIAN"
        :value="calendarType"
        @change="updateCalendarType(calendars.GREGORIAN)"
      >
        {{ $t('GREGORIAN_CALENDAR') }}
      </ElRadio>
    </div>

    <UiDatePicker
      v-bind="$attrs"
      :calendar-type="calendarType"
      @select-date="updateSelecedDate"
    />
  </div>
</template>

<script>
import UiDatePicker from '@@/layout/UiDatePicker';
import { calendars } from '@/constants/date';

export default {
  name: 'MonthSelector',
  components: { UiDatePicker },
  props: {
    calendarType: {
      type: String,
      required: true,
    },
  },
  computed: {
    calendars() {
      return calendars;
    },
  },
  methods: {
    updateCalendarType(type) {
      this.$emit('update:calendar-type', type);
    },
    updateSelecedDate(date) {
      this.$emit('update:selected-date', date);
    },
  },
};
</script>

<style lang="scss">
.month-selector {
  &__calendar-types {
    margin-top: $global-margin * 0.7;
    margin-bottom: $global-margin;
  }
}
</style>
